export function formatDate(date: string | Date): string {
  let year: string;
  let month: string;
  let day: string;

  if (date instanceof Date) {
    year = date.getFullYear().toString();
    month = String(date.getMonth() + 1).padStart(2, "0");
    day = String(date.getDate()).padStart(2, "0");
  } else {
    // 处理 ISO 8601 格式 (yyyy-mm-ddThh:mm:ss.sssZ) 或 YYYYMMDD 格式
    if (date.includes('-') && date.includes('T')) {
      const datePart = date.split('T')[0];
      if (datePart) {
        const parts = datePart.split('-');
        year = parts[0] || '';
        month = parts[1] || '';
        day = parts[2] || '';
      } else {
        year = '';
        month = '';
        day = '';
      }
    } else if (date.includes('-')) {
      const parts = date.split('-');
      year = parts[0] || '';
      month = parts[1] || '';
      day = parts[2] || '';
    } else {
      // 处理 YYYYMMDD 格式的字符串
      year = date.substring(0, 4);
      month = date.substring(4, 6);
      day = date.substring(6, 8);
    }
  }
  return `${year}-${month}-${day}`;
}

export function formatTime(timeOn: string): string {
  const hours = timeOn.substring(0, 2);
  const minutes = timeOn.substring(2, 4);
  return `${hours}:${minutes}`;
}

export function parseTime(time: string): number {
  const hours = parseInt(time.substring(0, 2), 10);
  const minutes = parseInt(time.substring(2, 4), 10);
  return hours * 60 * 60 * 1000 + minutes * 60 * 1000;
}

export function getTimestamp(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
}
